import spiderman from '@/spiderman/index';

async function get(member) {
  return (
    await spiderman.axios.get(spiderman.api.progressReminders,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function update(member, reminder) {
  return (
    await spiderman.axios.post(spiderman.api.progressReminders,
      reminder,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  get,
  update,
};
